import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("m7_dash_User_Id"),
        token: localStorage.getItem("m7_dash_Token"),
        usertype: localStorage.getItem("m7_dash_User_Type"),
        name: localStorage.getItem("m7_dash_User_name"),
        image: localStorage.getItem("m7_dash_userImg"),
        phone: localStorage.getItem("m7_dash_userPhone"),
        email: localStorage.getItem("m7_dash_userEmail"),
        gender: localStorage.getItem("m7_dash_userGender"),
        permissions: localStorage.getItem("m7_dash_permissions"),
      },
    };
  },
  mutations,
  actions,
  getters,
};